//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,countDownTimeFunc} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';

export default {
  name: "followOrder",
  components: {
    footerNav
  },
  data() {
    return {
      value:''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onSearch(){
    },
    toDetail(){
      this.$router.push({name:'followOrderDetail'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/followOrder/index.vue